export default [

// HDR'S
    {
        name: 'blockyStudio',
        type: 'HDR',
        path: 'HDR/blocky_photo_studio_1k.hdr'
    },
    {
        name: 'blueStudio',
        type: 'HDR',
        path: 'HDR/blue_photo_studio_1k.hdr'
    },
    {
        name: 'brownStudio',
        type: 'HDR',
        path: 'HDR/brown_photostudio_03_1k.hdr'
    },
    {
        name: 'photoStudio',
        type: 'HDR',
        path: 'HDR/photo_studio_london_hall_1k.hdr'
    },
    {
        name: 'studioSmall',
        type: 'HDR',
        path: 'HDR/studio_small_03_1k.hdr'
    },

// GLTF'S
    {
        name: 'Scene_0',
        type: 'gltfModel',
        path: 'models/scenes/scene_0.glb'
    },
    {
        name: 'Scene_1',
        type: 'gltfModel',
        path: 'models/scenes/scene_1.glb'
    },
    {
        name: 'Scene_3',
        type: 'gltfModel',
        path: 'models/scenes/scene_3.glb'
    },
    {
        name: 'light',
        type: 'gltfModel',
        path: 'models/light.glb'
    },

// AUDIO
    {
        name: 'Audio_Scene_0',
        type: 'audio',
        path: 'audio/Scene_0.mp3'
    },
    {
        name: 'Audio_Scene_2',
        type: 'audio',
        path: 'audio/Scene_2.wav'
    },
    {
        name: 'Audio_Scene_3',
        type: 'audio',
        path: 'audio/Scene_3.mp3'
    },

// TEXTURES
{
    name: 'aerial_asphalt',
    type: 'texture',
    folder: 'textures/aerial_asphalt'
},
{
    name: 'concrete_worn',
    type: 'texture',
    folder: 'textures/concrete_worn'
},
{
    name: 'cracked_concrete',
    type: 'texture',
    folder: 'textures/cracked_concrete'
},
{
    name: 'dithered_concrete',
    type: 'texture',
    folder: 'textures/dry_riverbed_rock'
},
{
    name: 'dry_riverbed_rock',
    type: 'texture',
    folder: 'textures/dry_riverbed_rock'
},
{
    name: 'granular_concrete',
    type: 'texture',
    folder: 'textures/granular_concrete'
},
{
    name: 'gravel',
    type: 'texture',
    folder: 'textures/gravel'
},
{
    name: 'gravel_concrete',
    type: 'texture',
    folder: 'textures/gravel_concrete'
},
{
    name: 'painted_concrete',
    type: 'texture',
    folder: 'textures/painted_concrete'
},
{
    name: 'plastered_wall',
    type: 'texture',
    folder: 'textures/plastered_wall'
},
{
    name: 'purple_floor',
    type: 'texture',
    folder: 'textures/purple_floor'
},
{
    name: 'rock_boulder',
    type: 'texture',
    folder: 'textures/rock_boulder'
},
{
    name: 'rocks',
    type: 'texture',
    folder: 'textures/rocks'
},
{
    name: 'stones',
    type: 'texture',
    folder: 'textures/stones'
},
{
    name: 'steel',
    type: 'texture',
    folder: 'textures/steel'
}
]

